import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ball-color-row" }
const _hoisted_2 = { class: "axis-label" }
const _hoisted_3 = { class: "color-row" }
const _hoisted_4 = ["onClick"]

import {
  BALL_COLOR_ORDER,
  BALL_COLOR_STYLES,
  type BallColorSlug,
} from '@/constants/sameColorBalls'


const __default__ = {
  name: 'BonusBallColorRow',
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const colorSlugs = BALL_COLOR_ORDER

function getColorButtonStyle(color: BallColorSlug, isSelected: boolean) {
  const style = BALL_COLOR_STYLES[color]
  if (isSelected) {
    return {
      backgroundColor: style.background,
      borderColor: style.border,
      color: style.text,
    }
  }

  return {
    backgroundColor: 'var(--bg-secondary, #fff)',
    borderColor: style.border,
    color: 'var(--text-primary)',
  }
}

function selectColor(color: BallColorSlug) {
  emit('update:modelValue', props.modelValue === color ? null : color)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('betting.ballColor')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorSlugs), (color) => {
        return (_openBlock(), _createElementBlock("button", {
          key: color,
          type: "button",
          class: _normalizeClass(["color-btn", { selected: _ctx.modelValue === color }]),
          style: _normalizeStyle(getColorButtonStyle(color, _ctx.modelValue === color)),
          onClick: ($event: any) => (selectColor(color))
        }, _toDisplayString(_unref(BALL_COLOR_STYLES)[color].label), 15, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})